import { render, staticRenderFns } from "./productTemplateVip01.vue?vue&type=template&id=25a43a58&scoped=true&"
import script from "./productTemplateVip01.vue?vue&type=script&lang=js&"
export * from "./productTemplateVip01.vue?vue&type=script&lang=js&"
import style0 from "./productTemplateVip01.vue?vue&type=style&index=0&id=25a43a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a43a58",
  null
  
)

export default component.exports